// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#verifySucceeded .success-icon[data-v-56c226e4] {\n  width: 60px;\n  height: 60px;\n}\n#verifySucceeded .success-info[data-v-56c226e4] {\n  font-size: 14px;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #333333;\n  line-height: 20px;\n}\n#verifySucceeded .success-tip[data-v-56c226e4] {\n  font-size: 18px;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #333333;\n  line-height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
